import { render, staticRenderFns } from "./iChecked.vue?vue&type=template&id=668c9804&scoped=true"
import script from "./iChecked.vue?vue&type=script&lang=js"
export * from "./iChecked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c9804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668c9804')) {
      api.createRecord('668c9804', component.options)
    } else {
      api.reload('668c9804', component.options)
    }
    module.hot.accept("./iChecked.vue?vue&type=template&id=668c9804&scoped=true", function () {
      api.rerender('668c9804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/iChecked.vue"
export default component.exports